import Modal from "react-modal";
import "./product-modal.css";
import useShoppingKartStore from "../../Stores/shoppingKartStore";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart, faXmark } from "@fortawesome/free-solid-svg-icons";
import useCotizadorStore from "../../Stores/cotizadorStore";

function ProductModalComponent({ isOpen, product, closeModal }) {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      zIndex: "20",
    },
  };

  const bgStyle = {
    backgroundPosition: "center",
    backgroundSize: "cover",
  };

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const addToKart = useShoppingKartStore((state) => state.addToKart);
  const addToCotizador = useCotizadorStore((state) => state.addToCotizador);

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
      <div className="modal-container">
        <FontAwesomeIcon
          icon={faXmark}
          onClick={() => closeModal()}
          style={{
            color: "black",
            position: "absolute",
            right: 5,
            top: 5,
            cursor: "pointer",
          }}
        />
        <div
          className="modal-product-photo"
          style={{
            backgroundImage: "url(" + product.productImg + ")",
            ...bgStyle,
          }}
        ></div>
        <div className="modal-text-section">
          <p className="modal-product-header">
            <b>{product.name}</b>
          </p>
          <span className="modal-product-price">
            {formatter.format(Number(product.price))}
          </span>
          <div className="modal-product-description">
            <span>{product.description}</span>
          </div>
          <div className="modal-span-container">
            <Button
              onClick={() => addToCotizador(product)}
              variant="contained"
              color="primary"
              style={{
                marginTop: "auto",
                width: "fit-content",
                marginBottom: "10px",
                marginLeft: "auto"
              }}
            >
              Añadir a Cotización
            </Button>
            <Button
              onClick={() => addToKart(product)}
              variant="contained"
              color="success"
              style={{
                marginTop: "auto",
                width: "fit-content",
                marginLeft: "auto",
              }}
            >
              Añadir al carrito{" "}
              <FontAwesomeIcon
                icon={faShoppingCart}
                style={{
                  color: "#FFFFFF",
                  marginLeft: "8px",
                  transform: "scale(1.1)",
                }}
              />
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ProductModalComponent;
